var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartOfSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#F8B692"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2204_2212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7329 11.7333H9.59961V19.2C9.59961 20.3733 10.5596 21.3333 11.7329 21.3333H21.3329V19.2H11.7329V11.7333Z",
    fill: "#F8B692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5339 6.39999H16.0005C14.8272 6.39999 13.8672 7.35999 13.8672 8.53333V14.9333C13.8672 16.1067 14.8272 17.0667 16.0005 17.0667H24.5339C25.7072 17.0667 26.6672 16.1067 26.6672 14.9333V8.53333C26.6672 7.35999 25.7072 6.39999 24.5339 6.39999ZM24.5339 14.9333H16.0005V10.6667H24.5339V14.9333Z",
    fill: "#F8B692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46634 16H5.33301V23.4667C5.33301 24.64 6.29301 25.6 7.46634 25.6H17.0663V23.4667H7.46634V16Z",
    fill: "#F8B692"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2204_2212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(5.33301 5.33333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartOfSource);
export default __webpack_public_path__ + "static/media/part_of_source.076c81d20118594965d33b9de36c8957.svg";
export { ForwardRef as ReactComponent };